import { buildUrl, createRequest } from './common/httpUtils'

/**
 * Get GPS trackers for a group
 */
export const getGroupGpsTrackers = async (groupId: GroupId): Promise<IGpsTracker[]> => {
  const url = buildUrl(`/api/v1/groups/${groupId}/gps_trackers`)
  const request = createRequest(url, 'GET')
  const response = await fetch(request)

  if (!response.ok) {
    throw new Error(`Failed to fetch GPS trackers: ${response.status}`)
  }

  return response.json()
}

/**
 * Get GPS tracker details by device token
 */
export const getGpsTrackerDetails = async (
  groupId: GroupId,
  deviceToken: string,
  options?: { date?: string },
): Promise<IGpsTracker> => {
  const query = options?.date ? `?date=${encodeURIComponent(options.date)}` : ''
  const url = buildUrl(`/api/v1/groups/${groupId}/gps_trackers/${deviceToken}${query}`)
  const request = createRequest(url, 'GET')
  const response = await fetch(request)

  if (!response.ok) {
    throw new Error(`Failed to fetch GPS tracker details: ${response.status}`)
  }

  return response.json()
}
